import React, {useState} from 'react';

import classNames from 'classnames';

import {Button, IButtonProps} from './../button';
import {Card, CardContent} from './../card';
import {Chart, IChartProps} from './../chart';
import {Grid, GridColumn} from './../grid';
import {IDateTime} from './../helpers';
import {IProgressProps, Progress} from './../progress';
import {FeedbackAnswers, IFeedbackAnswersProps} from '../feedback-answers';
import Count from '../count/count';
import {Dropdown} from '../dropdown';

export interface IQuestionProps {
    bars: IProgressProps[];
    chart: IChartProps;
    category: string;
    text: string;
    time?: IDateTime;
    actions?: IButtonProps[];
    className?: string;
    answers?: IFeedbackAnswersProps;
    hasMentor?: IButtonProps;
    titleTooltip?: string | JSX.Element;
}

const Question = (props: IQuestionProps): JSX.Element => {

    const [activeTab, setActiveTab] = useState<'results' | 'feedback'>('results');

    const className: string = classNames(
        'question',
        props.className,
    );

    return (
        <div className={className}>
            <Card className="question__card">
                <CardContent>
                    <div className="text">
                        <Grid align={['left-xs']} gutter='none'>
                            <GridColumn width={['max-xs']}>
                                <p>
                                    <span className="question__category text-small">{props.category}</span>
                                    {props.time ? <time className="question__time text-small"
                                        dateTime={props.time.iso}>{props.time.value}</time> : undefined
                                    }
                                    <span className="question__text">{props.text}</span>
                                </p>
                            </GridColumn>
                            {props.answers?.answers.length !== 0 &&
                                <GridColumn width={['min-xs']} className="question__icon-container">
                                    <Button
                                        text=''
                                        color="white"
                                        icon={activeTab === 'results' ? 'message' : 'bar-graph'}
                                        onClick={(event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>): void => {
                                            event.preventDefault();
                                            setActiveTab(activeTab === 'feedback' ? 'results' : 'feedback');
                                        }}
                                        style="link"
                                    />
                                    {props.answers && activeTab === 'results' && <Count
                                        className="question__count"
                                        number={props.answers.answers.length}
                                        color="red"
                                        size={'sm'}
                                    />}
                                </GridColumn>
                            }
                        </Grid>
                        <Grid>
                            <GridColumn width={['max-xs']} className="question__feedback-content">
                                {activeTab === 'results' && <>
                                    <Grid noWrap={['sm']} >
                                        <GridColumn width={['max-xs']}>
                                            <Grid wrap={['xs']} >
                                                {props.bars.map((bar: IProgressProps, i: number) => (
                                                    <GridColumn width={['xs']} key={i}>
                                                        <Progress {...bar} />
                                                    </GridColumn>
                                                ))}
                                            </Grid>
                                        </GridColumn>
                                        <GridColumn width={['min-xs']}>
                                            {props.hasMentor &&
                                                <GridColumn width={['xs']}>
                                                    {props.titleTooltip ?
                                                        <Dropdown
                                                            delayShow={200}
                                                            placement={'top'}
                                                            trigger={{children: <Button {...props.hasMentor} color={'white'} disabled={true} style={'filter'} iconLeft={'robot-happy'}/>}}>
                                                            {props.titleTooltip}
                                                        </Dropdown> : <Button {...props.hasMentor} color={'white'} style={'filter'} iconLeft={'robot-happy'}/>
                                                    }
                                                </GridColumn>
                                            }
                                        </GridColumn>
                                    </Grid>
                                </>}
                                {activeTab === 'feedback' && props.answers && <FeedbackAnswers {...props.answers}/>}
                            </GridColumn>
                        </Grid>
                    </div>
                </CardContent>
                {activeTab === 'results' && <>
                    <div className="question__chart-wrapper">
                        <Chart
                            {...props.chart}
                            aspect={46 / 7}
                            hideDots
                            hideGrid
                            hideXAxis
                            hideYAxis
                        />
                    </div>
                </>}
            </Card>
        </div>
    );
};

export default Question;
